import { render, staticRenderFns } from "./DailyChallengeMissionItem.vue?vue&type=template&id=1f0f8a90&scoped=true"
import script from "./DailyChallengeMissionItem.vue?vue&type=script&lang=js"
export * from "./DailyChallengeMissionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f8a90",
  null
  
)

export default component.exports